module.exports = __webpack_public_path__ + "static/media/kids_03.d5ad8971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_03.jpg
// module id = 5859
// module chunks = 0